export interface RiskVersionViewModel {
    id: string;
    name: string;
    description: string;
    created: Date;
    isLocked: boolean;
    area: RiskAssessmentVersionArea;
    isCurrent: boolean;
}

export interface RiskVersionSaveModel {
    id: string | null;
    name: string;
    description: string;
    isCurrent: boolean;
    area?: RiskAssessmentVersionArea;
}

export interface SelectableRiskAssessmentVersionViewModel {
    id: string;
    name: string;
    description: string;
    isCurrentVersion: boolean;
    isLocked: boolean;
    isCurrentRisk: boolean;
}

export enum RiskAssessmentVersionArea {
    GdprProcessingActivities = 1,
    GdprSystems = 2,
    Nis2ProcessingActivities = 3,
    Nis2Systems = 4,
}
